<template>
  <div class="d-flex mb-2 align-center justify-space-between" style="background-color: #c9c9c9">
    <div class="ml-3 py-1" style="font-size: large; font-weight: 500">
      {{ format(activity.activity_time!, 'MMMM dd, yyyy - HH:mm') }}
    </div>
    <MoreOptionsMenuButton
      v-if="
        currentUser?.hasPermission('guard_reports.change_guardreport') ||
        currentUser?.hasPermission('guard_reports.delete_guardreport')
      "
      tooltip-text="Activity Options"
    >
      <v-list-item
        v-if="currentUser.hasPermission('guard_reports.change_guardreport')"
        @click="openActivityDialog()"
      >
        <v-list-item-title>Edit Activity</v-list-item-title>
      </v-list-item>
      <v-list-item
        v-if="currentUser.hasPermission('guard_reports.delete_guardreport')"
        @click="openDeleteActivityDialog()"
      >
        <v-list-item-title> Delete Activity</v-list-item-title>
      </v-list-item>
    </MoreOptionsMenuButton>
  </div>

  <GuardReportActivityDetailTimeFormDialog
    v-if="activity"
    v-model:dialog="activityDetailDialog"
    :activity="activity"
    is-edit
    :report-id="report.id!"
  />

  <ConfirmationDialog v-model="activityDeleteDialog" v-model:error="error" title="Delete Activity">
    <template v-slot:message>
      Are you sure you want to delete this activity?
      <br />
      <div class="pt-2">This action cannot be undone.</div>
    </template>

    <template v-slot:actions>
      <v-spacer></v-spacer>

      <v-btn
        density="comfortable"
        color="error"
        variant="flat"
        class="text-capitalize"
        :loading="isDeletePending"
        @click.stop="deleteActivity()"
      >
        Delete
      </v-btn>
    </template>
  </ConfirmationDialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { storeToRefs } from 'pinia'
import { format } from 'date-fns'

import { useAuthStore } from '@/stores'
import type { IGuardReport, IGuardReportActivity } from '@/models/report'

import ConfirmationDialog from '@/components/common/ConfirmationDialog.vue'
import MoreOptionsMenuButton from '@/components/common/MoreOptionsMenuButton.vue'
import GuardReportActivityDetailTimeFormDialog from './GuardReportActivityDetailTimeFormDialog.vue'
import { useDeleteGuardReportActivity } from '@/composables/guard-report'

interface Props {
  report: IGuardReport
  activity: IGuardReportActivity
}
const props = defineProps<Props>()

interface Emits {
  (e: 'refresh-report'): void
}
const emit = defineEmits<Emits>()

const authStore = useAuthStore()
const { getUser: currentUser } = storeToRefs(authStore)

const activityDetailDialog = ref(false)
const activityDeleteDialog = ref(false)

function openActivityDialog() {
  activityDetailDialog.value = true
}

function openDeleteActivityDialog() {
  activityDeleteDialog.value = true
}

const {
  isPending: isDeletePending,
  error: error,
  mutate
} = useDeleteGuardReportActivity(props.report.id!)

function deleteActivity() {
  mutate(props.activity.id!, {
    onSuccess: () => {
      emit('refresh-report')
      activityDeleteDialog.value = false
    }
  })
}
</script>
